import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DEV_ONLY } from 'config/config';

const savedLang = localStorage.getItem('lang') || 'en';

i18n.use(initReactI18next).init({
  ...(!DEV_ONLY ? { fallbackLng: 'en' } : {}),
  lng: savedLang,
  resources: {
    ar: {
      translations: require('./locales/ar/translations.json'),
    },
    en: {
      translations: require('./locales/en/translations.json'),
    },
  },
  ns: ['translations'],
  defaultNS: 'translations',
});

i18n.languages = ['en', 'ar'];

export default i18n;
